import { v4 as uuidv4 } from 'uuid'
import { request } from '@remote/api/request'
import { numberToStringWithinObject } from '@remote/utils/base'
import type { IRes, IRequestCommonResponse } from './index.d'

export type TSvip = {
  // 0 | 1
  'isvip': number
  'vas_type': number
  'isyear': number
  'expire': number
  'expire_time': string
  // 0 | 1
  'autodeduct': number
  'activate_url': string
  'register': number
}

export interface IHeziAccountInfo {
  nickname: string
  userid: string
  username: string
  avatar: string
  /** 是否开启刮削：0否；1是 */
  is_scrape: 0 | 1
  /** 盒子会员信息 */
  vip: {
    /** 是否为盒子会员 */
    isvip: 0 | 1
    /** 是否为年费会员 */
    isyear: 0 | 1
    vas_type: number
    /** 是否自动续费 */
    autodeduct: 0 | 1
    /** 过期日期，如: 20240116 */
    expire: number
    /** 过期时间，YYYY-MM-DDTHH:mm:ssZ */
    expire_time: string
    /** 盒子会员激活链接 */
    activate_url: string
    /** 盒子会员购买链接 */
    pay_url: string
    /** 超会购买链接 */
    svip_pay_url: string
    /** 注册日期，如: 20230101 */
    register: number
  }
  /** 是否测试用户 */
  is_test: boolean
  /** 是否开启自动下载：0否；1是 */
  is_auto_download: 0 | 1
  /** 是否开启智能限速：0否；1是 */
  is_speed_limit: 0 | 1
  /** 开机自启共享服务：0否；1是 */
  is_auto_run_smb: 0 | 1
  /** 匿名访问共享服务：0否；1是 */
  is_smb_allow_anonymous: 0 | 1
  /** 开机自启转码服务：0否；1是 */
  is_auto_run_thumb: 0 | 1
  /** 是否开启备份服务：0否；1是 */
  is_auto_run_backer: 0 | 1
  /** 是否开启服务优先体验：0否；1是 */
  is_service_auto: 0 | 1
  /** 是否开启迅雷盒子App优先体验0否；1是 */
  is_app_exp: 0 | 1
  /** 是否为iOS审核用户 */
  is_audit: boolean
}

interface TGetHeziAccountInfoRes extends IHeziAccountInfo {
  'msg_config': {
    'circle_notice': 0
    'transfer_notice': 0
    'like_notice': 0
  }
  'registration_id': string
  'platform': string
  'svip': TSvip
}
// 获取盒子账号信息
export const getHeziAccountInfo = (): Promise<IRes<TGetHeziAccountInfoRes>> => {
  const url = '/api/v1/user/info'
  const params = { platform: 'pc' }
  return request(url, params, { apiEnv: 'heziProduction', method: 'POST' })
    .then(result => {
      return Array.isArray(result) ? result[1] : {}
    })
}

export type IHeziServiceConfigKeys = 
'is_service_auto' |
'is_auto_run_backer' |
'is_auto_run_smb' |
'is_auto_run_thumb' |
'is_smb_allow_anonymous' |
'is_auto_download'

type IHeziServiceConfig = Pick<
IHeziAccountInfo,
IHeziServiceConfigKeys
>
export function updateHeziServiceConfig (params: Partial<IHeziServiceConfig>, traceId = uuidv4()) {
  const url = '/api/v1/user/edit'
  const data = numberToStringWithinObject({ ...params, platform: 'pc' })
  return request(url, data, {
    apiEnv: 'heziProduction',
    method: 'POST',
    headers: {
      'X-Trace-Id': traceId,
    },
  }).then((response: IRequestCommonResponse<null>) => {
    const [err, result] = response
    if (err) {
      const { error, error_description, msg } = err
      const errMessage = `${msg}(#${error}: ${error_description})`
      throw new Error(errMessage)
    }
    console.log('[updateHeziServiceConfig][response]:', result)
    const { code, msg, data } = result
    if (code !== 200) {
      throw new Error(msg)
    }
    return data
  }).catch(err => {
    console.error(err)
    throw err
  })
}
